import { atomWithStorage } from 'jotai/utils';

import { CookieStorage } from '@core/Utils/CookieStorage';

export const nativeDeviceTokenAtom = atomWithStorage<string | null>(
  'deviceToken',
  null,
  CookieStorage,
);
